import ViewSongPluginsPerSong from './ViewSongPluginsPerSong';

export default ViewSongPluginsPerSong;
